import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

type ApiError = {
  error_code?: string | number;
  message?: string;
  [key: string]: unknown;
};

const isApiError = (error: unknown): error is ApiError => {
  return typeof error === "object" && error !== null;
};

export const convertApiError = (error: unknown): { error: FetchBaseQueryError } => {
  if (!isApiError(error)) {
    return {
      error: {
        status: "CUSTOM_ERROR" as const,
        error: String(error),
      },
    };
  }

  const errorMessage = error.message || String(error);

  return {
    error: {
      ...error,
      status: "CUSTOM_ERROR" as const,
      error: errorMessage,
    } as FetchBaseQueryError,
  };
};
